import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { Trans } from 'react-i18next';
import { MainLayout } from '../../MainLayout';
import { PageHeading } from '../../layout/PageHeading';
import { PianoIdentity } from '../../layout/PianoIdentity';
import { PrintButton } from '../../layout/PrintButton';
import { AnalysisFooter } from '@/components/analyze/key-reading/AnalysisFooter';
import { KeyReadingStrip } from '@/components/analyze/key-reading/KeyReadingStrip';
import { touchWeightReadingRows } from '@/components/analyze/key-reading/touch-weight-reading';
import { TouchWeightChart, type TouchWeightReadingContext } from '@/components/charts/touch-weight-chart/TouchWeightChart';
import { useAnalyzedKeyboard } from '@/hooks/keyboard/use-analyzed-keyboard';
import { useMeasureOptions } from '@/hooks/store/use-measure-options-store';
import { useTranslation } from '@/hooks/use-translation';
import { EMPTY_VALUE } from '@/lib/format/format-weight';
import { usePrintLandscape } from '@/hooks/use-print-page-size';
import { MeasureFirst } from '@/components/analyze/MeasureFirst';
export const AnalyzeTouchWeightPage = () => {
  const $ = _c(25);
  usePrintLandscape();
  const analyzedKeyboard = useAnalyzedKeyboard();
  const {
    currentLanguage,
    t
  } = useTranslation();
  const {
    useSupportSpringMeasurements
  } = useMeasureOptions();
  let t0;
  if ($[0] !== analyzedKeyboard || $[1] !== currentLanguage || $[2] !== t) {
    t0 = t1 => {
      const {
        frictionZoneLabel,
        hoveredKey,
        series
      } = t1;
      return <KeyReadingStrip reading={{
        keyNumber: hoveredKey,
        noteName: analyzedKeyboard.getKeyByNumber(hoveredKey ?? 0)?.name ?? null,
        rows: [...touchWeightReadingRows(series, hoveredKey, currentLanguage), {
          isQualitative: true,
          label: t("Friction zone"),
          value: frictionZoneLabel ?? EMPTY_VALUE
        }]
      }} />;
    };
    $[0] = analyzedKeyboard;
    $[1] = currentLanguage;
    $[2] = t;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const renderReading = t0;
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><PianoIdentity /><PrintButton /></>;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <em className="ptl-accent">Balance</em>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] !== t) {
    t3 = <Trans t={t} i18nKey="Static <1>Balance</1> & Friction">Static {t2}{" & Friction"}</Trans>;
    t4 = t("Spot the irregularities in your action.");
    $[6] = t;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <PageHeading title={t3} lede={t4} ledeWidth="62ch" />;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MeasureFirst />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== analyzedKeyboard || $[14] !== renderReading || $[15] !== useSupportSpringMeasurements) {
    t7 = <TouchWeightChart emptyState={t6} analyzedKeyboard={analyzedKeyboard} useSupportSpringMeasurements={useSupportSpringMeasurements} renderReading={renderReading} />;
    $[13] = analyzedKeyboard;
    $[14] = renderReading;
    $[15] = useSupportSpringMeasurements;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("Hover or tap the chart to read a key; use \u2190 \u2192 for the next one.");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <AnalysisFooter hint={t8} />;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t5 || $[22] !== t7 || $[23] !== t9) {
    t10 = <MainLayout headerRight={t1}>{t5}{t7}{t9}</MainLayout>;
    $[21] = t5;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};